import { Outlet, useRouterState } from '@tanstack/react-router';
import { useState } from 'react';

import { useSemRolagemLateral } from '@/lib/rolagemLateral';

import { Banner } from './Banner';
import { BarraSuperior } from './BarraSuperior';
import { Navegacao, Trilha } from './Navegacao';
import { NavegacaoDoParceiro } from './navegacao/NavegacaoDoParceiro';
import { Toasts } from './Toast';

/**
 * Casca da aplicacao (v2.1, p.34): menu lateral flutuante, barra superior
 * transparente e area de conteudo fluida. A mesma casca serve a todos os
 * modulos.
 *
 * O menu e um card que flutua a 12 px das bordas, a altura toda; a barra
 * superior e o conteudo moram ao lado dele, sobre o fundo da aplicacao. A
 * camada flutuante (p.30) fica por cima de tudo, cada elemento no seu lugar
 * fixo: o toast no canto inferior direito. O banner NAO flutua desde a R06
 * (p.67): entra no fluxo, entre a barra e a pagina, e empurra o conteudo.
 *
 * A margem interna NAO esta aqui, e sim em cada pagina (`pagina`). O motivo e
 * o painel de detalhe: ele se encosta a direita e vai do topo ao rodape, e uma
 * margem na casca o descolaria — ou o obrigaria a compensar com margem
 * negativa, que e pior.
 *
 * Pontos de quebra (p.18): 1600 / 1280 / 1024 / 768. Menu aberto a partir de
 * 1280, trilho de icones entre 1024 e 1279, gaveta pelo ☰ abaixo de 1024.
 */
export function Estrutura({
  parceiro = false,
}: {
  /**
   * A pessoa de posto parceiro (decisão 58, 0132): o menu com o lançamento só,
   * sem a busca da barra e sem a trilha, que nomearia módulos que ela não abre.
   */
  readonly parceiro?: boolean;
} = {}) {
  const [gavetaAberta, setGavetaAberta] = useState(false);
  /* Verificador em desenvolvimento: a pagina nao rola de lado (p.18). */
  useSemRolagemLateral(useRouterState({ select: (estado) => estado.location.pathname }));
  return (
    <div className="flex h-full bg-tela">
      {parceiro ? (
        <NavegacaoDoParceiro
          gavetaAberta={gavetaAberta}
          aoFecharGaveta={() => {
            setGavetaAberta(false);
          }}
        />
      ) : (
        <Navegacao
          gavetaAberta={gavetaAberta}
          aoFecharGaveta={() => {
            setGavetaAberta(false);
          }}
        />
      )}

      <div className="relative flex min-h-0 min-w-0 flex-1 flex-col">
        <BarraSuperior
          trilha={parceiro ? null : <Trilha />}
          semBusca={parceiro}
          menuAberto={gavetaAberta}
          aoAbrirMenu={() => {
            setGavetaAberta(true);
          }}
        />
        {/* O banner da R06 (p.67): no fluxo, entre a barra e o cabecalho da
            pagina; empurra o conteudo e nunca o cobre. */}
        <Banner />
        <main className="flex min-h-0 min-w-0 flex-1">
          <Outlet />
        </main>
      </div>

      {/* O retorno de toda chamada: o toast da camada flutuante (p.31). */}
      <Toasts />
    </div>
  );
}
